export const getPaginatedData = (clients, page, pageSize) => {
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  return clients.slice(startIndex, endIndex);
};

export const getTotalPages = (totalItems, pageSize) => {
  return Math.ceil(totalItems / pageSize);
};
